export default __webpack_public_path__ + "static/media/Rush.85026cbc.jpeg";